import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Product, WindowRef } from '@spartacus/core';
import { ProductComparatorFloating } from '../../product-comparator/core/product-comparator.model';
import { LocalStorageService } from '../../../../../core/services/localStorage.service';

@Injectable({
  providedIn: 'root',
})
export class ProductComparatorFloatingService {
  storeInitialState: ProductComparatorFloating = { products: [] };
  store$ = new BehaviorSubject<ProductComparatorFloating>(this.storeInitialState);
  maxProducts = 3;
  expanded$ = new BehaviorSubject<boolean>(true);

  constructor(
    private localStorageService: LocalStorageService,
    private winref: WindowRef,
  ) {}

  addProduct(product: Product) {
    const store = this.store$.getValue();
    const isDifferentProduct = !store.products?.some(p => p.code === product.code);

    if (isDifferentProduct) {
      this.store$.next({
        products: [...store.products, product],
      });
    }
  }

  removeProduct(code: string) {
    const store = this.store$.getValue();

    this.store$.next({
      products: store.products?.filter(product => product.code !== code),
    });
  }

  removeAllProducts() {
    this.store$.next({ products: [] });
  }

  getCurrentStatus(): 'closed' | 'expanded' {
    if (this.winref.isBrowser()) {
      return (
        (this.localStorageService.getItem('productFloattingComparatorState') as 'closed' | 'expanded') || 'expanded'
      );
    }

    return 'closed';
  }

  closeContainer() {
    if (this.winref.isBrowser()) {
      const $container = this.winref.document.querySelector('.js-container-product-comparator') as HTMLDivElement;
      $container.style.bottom = -$container.clientHeight + 'px';
      this.expanded$.next(false);
      this.localStorageService.setItem('productFloattingComparatorState', 'closed');
    }
  }

  openContainer() {
    if (this.winref.isBrowser()) {
      const $container = this.winref.document.querySelector('.js-container-product-comparator') as HTMLDivElement;
      $container.style.bottom = '0';
      this.expanded$.next(true);
      this.localStorageService.setItem('productFloattingComparatorState', 'expanded');
    }
  }
}
